import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import TeamsShowcaseSection from "../teams/TeamsShowcaseSection";

export default function MainLayout() {
    return (
        <div className="min-h-screen bg-transparent text-white">
            <AppHeader />
            <TeamsShowcaseSection />
            <main className="mx-auto w-full max-w-[1400px] px-4 py-6 md:px-6 lg:px-8">
                <Outlet />
            </main>

            <AppFooter />
        </div>
    );
}